import FarloUiRevolverCarousel from './farlo-ui-revolver-carousel.js';

class FarloUiLightbox {
	constructor(element, options = {}) {
		this.element = element;
		this.options = options;

		this.carouselEnabled = this.checkCarouselEnabled();
		this.currentCarouselIndex = 0;
		const youTubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

		if (this.carouselEnabled) {
			this.carouselItems = Array.from(this.element.children);
			this.carouselItems.forEach((item, index) => {
				item.addEventListener('click', (event) => {
					event.preventDefault();
					this.currentCarouselIndex = index;
					this.openLightbox();
				});
			});
		} else {
			this.element.addEventListener('click', (event) => {
				event.preventDefault();
				this.openLightbox();
			});
		}

		this.initialiseLightboxContainer();
		this.lightbox = document.querySelector('.farlo-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.farlo-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner');
		this.closeButton = this.lightbox.querySelector('.farlo-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');

		this.element.addEventListener('click', this.openLightbox.bind(this));
		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
	}

	checkCarouselEnabled() {
		const parentElement = this.element.closest('.farlo-ui-revolver-carousel--enabled');
		return parentElement ? true : false;
	}

	helperIsImageType(src) {
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && checkedElement.value && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}

	initialiseLightboxContainer() {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .wp-block-gallery');
		if (lightboxEmbed.length > 0) {
			const div = document.createElement('div');
			const divInner = document.createElement('div');
			const divInnerContent = document.createElement('div');
			const divClose = document.createElement('button');
			const divBackdrop = document.createElement('div');
			div.className = 'farlo-ui-lightbox';
			divInner.className = 'farlo-ui-lightbox__inner';
			divInnerContent.className = 'farlo-ui-lightbox__content-inner';
			divClose.className = 'farlo-ui-lightbox__close';
			divBackdrop.className = 'farlo-ui-lightbox__backdrop';

			// Append elements to create the lightbox container
			div.appendChild(divInner);
			divInner.appendChild(divInnerContent);
			divInner.appendChild(divClose);
			div.appendChild(divBackdrop);
			document.body.appendChild(div);
		}
	}

	openLightbox() {
		const content = this.generateGalleryContent(this.carouselEnabled ? this.element : this.element.parentNode, this.options.carousel);
		this.lightboxContentInner.innerHTML = content;

		if (this.options.carousel && this.carouselEnabled) {
			const carouselElement = this.lightboxContentInner.querySelector('.farlo-ui-revolver-carousel');
			if (carouselElement) {
				this.carousel = new FarloUiRevolverCarousel(carouselElement, { initialIndex: this.currentGalleryIndex });
			}
		}

		this.lightbox.classList.add('farlo-ui-lightbox--active');
		this.lightbox.removeAttribute('aria-hidden');
		this.lightbox.focus();
	}

	closeLightbox() {
		this.lightbox.classList.remove('farlo-ui-lightbox--active');

		setTimeout(() => {
			if (!this.element.nextElementSibling && typeof this.element.nextElementSibling.childNodes === 'undefined' && !this.element.nextElementSibling.classList.contains('farlo-ui-lightbox')) {
				this.lightboxContentInner.innerHTML = '';
			}
			this.lightbox.setAttribute('aria-hidden', 'true');
			this.element.focus();
		}, 300);
	}

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
	}

	generateGalleryContent(element, isCarousel) {
		let content = '';

		if (isCarousel) {
			content += '<div class="farlo-ui-revolver-carousel">';
			Array.from(element.children).forEach((item, index) => {
				content += `
                    <div class="farlo-ui-revolver-carousel__chamber">
                        ${ item.innerHTML }
                    </div>
                `;
			});
			content += '</div>';
		} else {
			content += element.innerHTML;
		}

		return content;
	}

	generateCarouselContent(element, isCarousel) {
		let content = '';

		if (isCarousel) {
			content += '<div class="farlo-ui-revolver-carousel">';
			Array.from(element.children).forEach((item, index) => {
				content += `
                    <div class="farlo-ui-revolver-carousel__chamber">
                        ${ item.innerHTML }
                    </div>
                `;
			});
			content += '</div>';
		} else {
			content += element.innerHTML;
		}

		return content;
	}
}

export default FarloUiLightbox;
